module.exports = __webpack_public_path__ + "img/Audi-Fahrzeugschein-Beispiel.c072df44.png";